import { Select } from "@planningcenter/doxy-web"
import { useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { WebBootContext } from "source/publishing/WebBoot"
import { Menu, MenuButton, MenuList, MenuLink } from "@reach/menu-button"
import { useHouseholds } from "source/myChurchCenter/ProfileAndHousehold/hooks/useHouseholds"
import { useSearchParams } from "source/myChurchCenter/hooks/useSearchParams"
import { Icon } from "source/shared/components"

export function ProfileSelect({
  profileId,
  canAddHouseholdMember,
}: {
  profileId: string
  canAddHouseholdMember: boolean
}) {
  const [searchParams, setSearchParams] = useSearchParams()

  const { data: households } = useHouseholds()

  const household =
    households.find(
      (household) => household.id === searchParams.get("household"),
    ) || households[0]

  const [selected, setSelected] = useState(profileId)

  const {
    abilities: {
      people: {
        add_or_remove_household_members: addOrRemoveHouseholdMembersEnabled,
      },
    },
  } = useContext(WebBootContext)

  function handleChangeOrBlur(
    event:
      | React.ChangeEvent<HTMLSelectElement>
      | React.FocusEvent<HTMLSelectElement>,
  ) {
    setSelected(event.target.value)
  }

  useEffect(() => {
    setSearchParams((s) => {
      s.set("profile", selected)
      return s
    })
  }, [selected, setSearchParams])

  if (!household) return null

  return (
    <div
      className="d-f ai-c g-2 mb-3"
      css={{
        select: {
          borderRadius: 40,
        },
      }}
    >
      <Select
        id="profile"
        onBlur={(e) => handleChangeOrBlur(e)}
        onChange={(e) => handleChangeOrBlur(e)}
        value={selected}
      >
        {household.householdMembers.map((member) => (
          <Select.Option
            key={member.personId}
            label={member.name}
            value={member.personId}
          />
        ))}
      </Select>
      {addOrRemoveHouseholdMembersEnabled && canAddHouseholdMember && (
        <Menu>
          <div>
            <MenuButton
              className="btn p-0 f-0"
              style={{ width: 40, height: 40, borderRadius: "100%" }}
              aria-label="Add household member"
            >
              <Icon symbol="general#plus" className="fs-1" aria-hidden />
            </MenuButton>
          </div>

          <MenuList
            className="dropdown__menu"
            css={{ "--dropdown-menu--font-size": "1rem" }}
          >
            <MenuLink
              as={Link}
              to={`/households/${household.id}/household-members/new?type=adult`}
              className="dropdown__item"
            >
              Add adult
            </MenuLink>
            <MenuLink
              as={Link}
              to={`/households/${household.id}/household-members/new?type=child`}
              className="dropdown__item"
            >
              Add child
            </MenuLink>
          </MenuList>
        </Menu>
      )}
    </div>
  )
}
